<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          虚拟条码：<span v-if="formData.billNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.billNo
          }}</span>
          <span v-else class="information"> 待生成</span>
          <!-- 状态 -->
          <span v-if="formData.stat == 1" class="information">制单</span>
          <span class="information" v-else-if="formData.stat == 2">待确定</span>
          <span class="information" v-else-if="formData.stat == 3">待申诉</span>
          <span class="information" v-else-if="formData.stat == 5">已申诉</span>
          <span class="information" v-else-if="formData.stat == 7">执行考核</span>
          <span class="information" v-else-if="formData.stat == 9">已结算</span>
          <span class="information" v-else-if="formData.stat == 19">取消执行</span>
          <span class="information" v-else-if="formData.stat == 99">关闭</span>
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="!justShow" @click="saveData">保存
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check"
            v-if="_dataId && !isSite && (formData.stat != 7 && formData.stat != 99) && sfCheckBillClose"
            @click="showCloseDialog = true">考核关闭
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check"
            v-if="_dataId && !isSite && (formData.stat == 5) && sfCheckBillCheck" @click="showAuditDialog = true">申诉审核
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="isSite && formData.stat == 3"
            @click="initiateAppeal = true">申诉
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="isSite && formData.stat == 3"
            @click="cancleAppeal">放弃申诉
          </el-button>

          <!--          <el-button type="primary" class="button-sty" icon="el-icon-bottom" v-if="!isSite && formData.stat==2 && this.type!='wf'"-->
          <!--                     @click="showConfirmDialog=true">确认考核-->
          <!--          </el-button>-->
          <!--          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="!isSite && formData.stat==5 && this.type!='wf'"-->
          <!--                     @click="showAuditDialog=true">执行考核-->
          <!--          </el-button>-->
          <!--          <el-button type="primary" class="button-sty" icon="el-icon-close"-->
          <!--                     v-if="!isSite && formData.stat==1 && this.type!='wf'"-->
          <!--                     @click="showCloseDialog=true">取消考核-->
          <!--          </el-button>-->
        </div>
      </div>
      <div>
        <div>
          <!-- 品牌信息 -->
          <div class="d-cont edit-mce-box" style="height: 100%;margin:0 !important;padding:0 !important;">
            <div class="d-item">
              <div class="title first">
                <b>主信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      部门名称
                    </th>
                    <td>
                      <el-select v-model="formData.orgId" placeholder="请选择品牌" @change='brandSelectOne' clearable>
                        <el-option v-for="item in brandOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      网点名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable :readonly="true">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop = true"></i>
                      </el-input>
                    </td>
                    <th>
                      联系人
                    </th>

                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.siteMan" clearable />
                    </td>
                    <th>
                      联系人电话
                    </th>

                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.siteMobile" clearable />
                    </td>
                  <tr>
                    <th>
                      虚拟条码
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.virtualBarcode" :disabled="true" clearable />
                    </td>
                  </tr>
                  <!--
                    <th>
                      关联工单
                    </th>
                    <td v-if="justShow">{{ formData.orderNo }}</td>
                    <td v-else>
                      <el-input type="text" autocomplete="off" v-model="formData.orderNo" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialogFunc"></i>
                      </el-input>
                    </td> -->

                  </tr>

                  <tr>
                    <th>创建人</th>
                    <td>{{ formData.createBy }}</td>
                    <th>创建时间</th>
                    <td>{{ formData.createTime }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-item">
              <div class="title first">
                <b>申请信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      关联工单
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.orderNo" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialogFunc"></i>
                      </el-input>
                    </td>
                    <th>
                      服务类型
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.serverTypeId" :disabled="true" clearable />
                    </td>
                    <th>
                      用户姓名
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.userName" :disabled="true" clearable />
                    </td>
                    <th>
                      用户电话
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.userMobile" :disabled="true" clearable />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      产品条码
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.barcode" clearable />
                    </td>
                    <th>
                      产品编码
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.itemCode" :disabled="true" clearable />
                    </td>
                    <th>
                      产品名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.itemName" :disabled="true" clearable />
                    </td>
                    <th>
                      产品分类
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.bigCategoryName" :disabled="true" clearable />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <em class="f-red">*</em>购买日期
                    </th>
                    <td>
                      <el-date-picker v-model="formData.buyDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
                        type="date" placeholder="选择日期">
                      </el-date-picker>
                    </td>
                    <th>
                      经销商
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.buySaler" clearable />
                    </td>
                    <th>
                      条码使用情况
                    </th>
                    <td colspan="3" style="position: relative;">
                      <el-input type="text" autocomplete="off" v-model="formData.useStatus" :disabled="true" clearable />  <span style="position: absolute;right:-15px;top: 12px;" class="Instructions">检测</span>
                    </td>

                  </tr>

                  <!-- <tr v-if="!justShow" style="position: absolute;top: 170px;">
                    <th>凭证1</th>
                    <td colspan="">
                      <div v-if="showPhoto">
                        <el-upload style="display:flex" :class="{ hide_box4: upload_btn1 }" :action="uploadFileUrl"
                          :on-remove="handleRemove1" list-type="picture-card" :file-list="picList1"
                          :on-success="(res, file, fileList) => { handleSuccess1(res, file, fileList) }"
                          :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                          :headers="headers" :on-preview="handlePictureCardPreview">
                          <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </td>
                    <th>凭证2</th>
                    <td colspan="">
                      <div v-if="showPhoto">
                        <el-upload style="display:flex" :class="{ hide_box4: upload_btn2 }" :action="uploadFileUrl"
                          :on-remove="handleRemove2" list-type="picture-card" :file-list="picList2"
                          :on-success="(res, file, fileList) => { handleSuccess2(res, file, fileList) }"
                          :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                          :headers="headers" :on-preview="handlePictureCardPreview">
                          <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </td>
                    <th>凭证3</th>
                    <td colspan="">
                      <div v-if="showPhoto">
                        <el-upload style="display:flex" :class="{ hide_box4: upload_btn3 }" :action="uploadFileUrl"
                          :on-remove="handleRemove3" list-type="picture-card" :file-list="picList3"
                          :on-success="(res, file, fileList) => { handleSuccess3(res, file, fileList) }"
                          :on-change="(files, fileList) => { handleImageChange(fileList) }" :auto-upload="true"
                          :headers="headers" :on-preview="handlePictureCardPreview">
                          <i slot="default" class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </td>
                  </tr> -->
                  <!-- <tr v-else>
                    <th>考核凭证</th>
                    <td style="display: flex; height: 80px" colspan="6">
                      <div style="display:flex; margin-right: 20px; height: 60px">
                        <el-image v-if="formData.proofAttachment1" :preview-src-list="showPhotoList0" fit="fill"
                          :src="formData.proofAttachment1" :initial-index="0" style="margin-bottom: 10px;"></el-image>
                        <el-image v-else>
                          <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"
                              style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                          </div>
                        </el-image>
                      </div>

                      <div style="display:flex; margin-right: 20px; height: 60px">
                        <el-image v-if="formData.proofAttachment2" :preview-src-list="showPhotoList0" fit="fill"
                          :src="formData.proofAttachment2" :initial-index="1"></el-image>
                        <el-image v-else>
                          <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"
                              style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                          </div>
                        </el-image>
                      </div>

                      <div style="display:flex; margin-right: 20px; height: 60px">
                        <el-image v-if="formData.proofAttachment3" :preview-src-list="showPhotoList0" fit="fill"
                          :src="formData.proofAttachment3" :initial-index="2"></el-image>
                        <el-image v-else>
                          <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"
                              style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                          </div>
                        </el-image>
                      </div>
                    </td>
                  </tr> -->

                </tbody>
              </table>
            </div>

            <div class="d-item" style="position: relative;height: 200px;">
              <div class="title first" style="    display: flex;justify-content: space-between;">
                <b>回访情况</b>
                <el-button type="primary" class="button-sty btn_zdy" @click="showStarLevelDialog = true; starLevelObj = null">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
              </div>
              <vxe-table :stripe="true"
                  :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                  :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                  show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                  :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                  :data="formData.snSiteStarLevelDTOS">

                  <vxe-column type="seq" title="序号" width="60" />
                  <vxe-column field="billId" title="申请单号" width="150" />

                  <vxe-column field="huiFangQingKuang" title="回访情况" width="110" />
                  <vxe-column field="notTrueReasonName" title="不属实原因" width="150" />
                  <vxe-column field="recallRemark" title="回访描述" width="250" />

                  <vxe-column field="recallMan" title="回访员" width="110" />
                  <vxe-column field="recallDate" title="回访时间" width="110" />

                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a href="javascript:void(0);" class="a-link" @click="editStarLevel(row)">
                        <el-tooltip effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-edit" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>
            </div>

            <div class="d-item">
              <div class="title first">
                <b>附件列表</b>
              </div>

            </div>
          </div>

        </div>
      </div>
    </el-form>

    <el-drawer title="发起申诉" :visible.sync="initiateAppeal" direction="rtl" custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="form2">
          <el-form-item label="申诉原因" :label-width="formLabelWidth">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="form2.siteAnswerNote"
              autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="申诉凭证" :label-width="formLabelWidth">
            <el-upload class="upload-demo" :action="api.uploadFileUrl"
              :on-success="(res, file, fileList) => { handleSuccess2(res, file, fileList) }" :on-preview="handlePreview"
              :on-remove="handleRemove" :file-list="fileList" :limit="3" :headers="headers" list-type="picture">
              <td align="left">
                <el-button size="small" type="primary">点击上传</el-button>
              </td>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="toInitiateAppeal" :loading="loading">
            {{ loading ? '提交中 ...' : '确 定' }}
          </el-button>
        </div>
      </div>
    </el-drawer>


    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList" />


    <sitePop v-if="showSitePop" :visiable.sync="showSitePop" :multi="true" @commit="siteCommit" />

    <orderPop v-if="showOrderPop" :visiable.sync="showOrderPop" multi="false" @commit="orderCommit"
      :siteId="formData.siteId" />

    <closeDialog v-if="showCloseDialog" :close-id="dataId" @closeD="closeD" :visiable.sync="showCloseDialog" multi="true"
      @flushed="editViewDataUpdate" />

    <confirmDialog v-if="showConfirmDialog" :confirmNo="formData.billNo" :dataId="dataId" @closeD="closeD"
      :visiable.sync="showConfirmDialog" multi="true" @flushed="editViewDataUpdate" />

    <auditDialog v-if="showAuditDialog" :dataId="dataId" @closeD="closeD" :visiable.sync="showAuditDialog" multi="true"
      @flushed="editViewDataUpdate" />
      <!-- 回访-->
      <starLevel v-if="showStarLevelDialog" @commitData="commitStarLevelData" :visiable.sync="showStarLevelDialog" :starLevelObj="starLevelObj"
      multi="true" />
  </div>
</template>
<script>
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch.vue"
import Tinymce from '@/components/Tinymce';
import store from "@/store";
import api from '@/api/projectApi'
import { uploadFileFormat, echoFileFormat } from '@/util/uploadFormat'
import sitePop from "@/views/dialogCommon/radioSiteDialog.vue"
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import auditDialog from "@/views/expense/assessment/assessment1/auditDialog.vue";
import confirmDialog from "@/views/expense/assessment/assessment1/confirmDialog.vue";
import closeDialog from "@/views/expense/assessment/assessment1/closeDialog.vue";
import DictSelect from "@/components/formItem/dictSelect.vue";
import { mapGetters } from "vuex";
// 回访
import starLevel from './starLevel.vue';
export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
    type: String,
  },
  components: {
    starLevel,
    DictSelect,
    checkSubjectSearch,
    closeDialog, confirmDialog, auditDialog,
    sitePop,
    Tinymce,
    orderPop,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      showStarLevelDialog: false,

      loading: false,
      // 流程
      processId: '',

      wfData: {
        wfEntityId: ''
      },
      initiateAppeal: false,
      formLabelWidth: '80px',
      justShow: false,
      showCloseDialog: false,
      showConfirmDialog: false,
      showAuditDialog: false,
      isSite: null,

      dialogImageUrlList: [],
      dialogVisible: false,
      uploadFileUrl: api.uploadFileUrl,

      form2: {
        appealRemark: '',
        siteAnswerNote: '',
      },
      formData: {
        snSiteStarLevelDTOS:[],
        checkSubjectName: '',
        infoSource: null,
        infoSourceName: null,
        billNo: '',  // 考核单号,前缀"CK"+年月日+6位流水号
        stat: 1,  // 状态：1制单；2.待确认；3待申诉；5已申诉；7执行考核；9已结算；19取消执行；99关闭
        orgId: 0,  // 业务机构，关联脚手架机构表.id
        orgName: '',  // 机构名称,冗余字段
        orgIdPath: '',  // 机构ID路径,冗余字段.重要
        siteId: null,  // 网点ID,关联sn_user.id;
        siteName: '',  // 网点名称,冗余字段
        brandId: '',  // 品牌ID,关联sn_company_brand.id
        brandName: '',  // 品牌名称,冗余字段
        orderId: '',  // 工单id，关联so_order.id.非必填
        orderNo: '',  // 工单号，冗余字段
        // settleId: 0,  // 结算单ID,关联sf_batch_settle.id字段
        checkSubjectId: '',  // 考核科目,关联bas_check_subject.id
        feeAttributeId: '',  // 费用类型,关联sn_company_fee_attribute.id
        feeAttributeName: '',  // 费用类型名称,显示用
        standardAmount: 0,  // 考核金额
        adjustAmount: 0,  // 调整金额
        amount: 0,  // 合计金额:standardAmount+adjustAmount
        proofAttachment1: '',  // 考核凭证1
        proofAttachment2: '',  // 考核凭证2
        proofAttachment3: '',  // 考核凭证3
        isNeedSiteComplain: 1,  // 是否需要网点申诉:0否1是
        siteAnswerDate: '',  // 网点申诉时间
        siteAnswerNote: '',  // 网点申诉意见
        answerAttachment1: '',  // 网点申诉凭证1
        answerAttachment2: '',  // 网点申诉凭证2
        answerAttachment3: '',  // 网点申诉凭证3
        remark: '',  // 考核内容

        picList1: [],
        picList2: [],
        picList3: [],

        checkResult: null, // 审批结果:1申诉成立;2申诉不成立
        checkMan: '',  // 最终审批人
        checkAmount: '',  // 最终审批金额(结算时使用此金额)
        checkDate: '',  // 最终审批时间
        checkNote: '',  // 最终审批意见
      },
      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],
      picList5: [],
      picList6: [],
      showPhotoList0: [],
      showPhotoList1: [],
      operationDTOList: [],

      showPhoto: true,
      checkSubjectOption: [],
      brandOptions: [],
      showSitePop: false,

      showProductCategoryDialog: false,
      showOrderPop: false,

      upload_btn1: true,
      upload_btn2: true,
      upload_btn3: true,

      radio: '1',
      showEdit: false,

      activeName: 'first',
      dialog: {
        one: false,
      },
      fileList: [],

      isEdit: false,
      dataId: '',
    };
  },
  watch: {
    'formData.adjustAmount': {
      handler(newVal, oldVal) {
        if (this.formData.standardAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.standardAmount': {
      handler(newVal, oldVal) {
        if (this.formData.adjustAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.checkSubjectId': {
      deep: true,
      handler(newVal) {
        this.checkSubjectSelectOne()
      }
    }
  },

  computed: {
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
    api() {
      return api
    },
    ...mapGetters(["permissions"])

  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;

    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;
    console.log(this.wfData.wfEntityId, "ccccprocessId");
    const userInfo = store.getters.userInfo;
    this.sfCheckBillClose = this.permissions["sfCheckBillClose"];
    this.sfCheckBillCheck = this.permissions["sfCheckBillCheck"];
    this.sfCheckBillSubmit = this.permissions["sfCheckBillSubmit"];
    this.sfCheckBillCancel = this.permissions["sfCheckBillCancel"];
    if (userInfo.snUserId) {
      this.isSite = true;
    }
  },

  mounted() {
    this.getData();
    this.loadBrandOption()
    this.loadCheckSubjectOption()
    this.loadLoginIsSite()
  },

  methods: {

    commitStarLevelData(data){
      if (!this.formData.snSiteStarLevelDTOS) {
        this.formData.snSiteStarLevelDTOS = []
      }

      console.log("data",data)
      let filter = this.formData.snSiteStarLevelDTOS.filter(item => item.billId !== data.billId)
      filter.push(data)
      this.formData.snSiteStarLevelDTOS = filter
      console.log("this.formData.snSiteStarLevelDTOS",this.formData.snSiteStarLevelDTOS)
    },
    editStarLevel(row){
      this.starLevelObj = row
      this.showStarLevelDialog = true
    },
    editViewDataUpdate() {
      this.$emit('editViewDataUpdate')
      this.$emit('changeTab')
    },

    handleSuccess2(res, file, fileList) {
      this.fileList.push(res.data.url)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showConfirmDialog = false
      this.showCloseDialog = false
      this.showAuditDialog = false
      // this.flushed()
    },

    closeImgViewer() {
      this.dialogVisible = false
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    showPreconditionDialogFunc() {
      if (this.formData.siteId !== '' && this.formData.siteId !== null)
        this.showOrderPop = true
      else
        this.$message.warning('请先选中网点')
    },

    checkSubjectSelectOne() {
      if (this.formData.checkSubjectId) {
        this.$http.post(api.basCheckSubject.getDataUrl, { id: this.formData.checkSubjectId }).then(res => {
          let data = res.data.data
          this.formData.standardAmount = data.standardAmount
          this.formData.feeAttributeName = data.feeAttributeName
          this.formData.feeAttributeId = data.feeAttributeId
          this.formData.isNeedSiteComplain = data.isNeedSiteComplain
        })
        console.log(this.formData)
        // this.processId = this.formData.processId;
        // console.log(this.processId,'this.processId的值');
      } else {
        this.formData.standardAmount = 0
        this.formData.feeAttributeName = null
        this.formData.feeAttributeId = null
        this.formData.isNeedSiteComplain = null
      }
    },

    loadCheckSubjectOption() {
      this.$http({
        url: api.basCheckSubject.getListUrl,
        method: 'post',
        data: {
          usable: 1,
          useWhere: 1
        }
      }).then(res => {
        this.checkSubjectOption = []
        res.data.data.forEach(item => {
          this.checkSubjectOption.push({
            label: item.name,
            value: item.id,
            feeAttributeId: item.feeAttributeId,
            feeAttributeName: item.feeAttributeName,
            standardAmount: item.standardAmount,
            isNeedSiteComplain: item.isNeedSiteComplain
          })
        })
      })
    },

    //加载判断当前登录是否网点
    loadLoginIsSite() {
      this.$http({
        url: api.snUser.getLoginIsSite,
        method: 'post',
        data: {}
      }).then(res => {
        console.log("当前登录信息",res.data)
      })
    },

    brandSelectOne() {
      if (this.formData.orgId !== '') {
        this.brandOptions.forEach(item => {
          if (item.value === this.formData.orgId) {
            this.formData.brandName = item.label
          }
        })
      }
    },

    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: api.snCompanyBrand.getBrandListUrl,
        method: 'post',
        data: {
          usable: 1  // 加载启用的
        }
      }).then(res => {
        this.brandOptions = []
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },

    getOperationData(id) {
      this.$http({
        url: api.sfCheckBillOperation.getList,
        method: 'post',
        data: { checkBillId: id }
      }).then(res => {
        this.operationDTOList = res.data.data
      })
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.sfCheckBill.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data;
          this.formData = data
          this.showPhoto = false
          if (this.justShow) {
            this.showPhotoList0 = [data.proofAttachment1, data.proofAttachment2, data.proofAttachment3]
            this.showPhotoList1 = [data.answerAttachment1, data.answerAttachment2, data.answerAttachment3]
          } else {
            this.picList1 = echoFileFormat(data.proofAttachment1)
            this.picList2 = echoFileFormat(data.proofAttachment2)
            this.picList3 = echoFileFormat(data.proofAttachment3)

            this.picList4 = echoFileFormat(data.answerAttachment1)
            this.picList5 = echoFileFormat(data.answerAttachment2)
            this.picList6 = echoFileFormat(data.answerAttachment3)
          }
          this.justShow = this.formData.stat != 2
          //流程任务进来的
          if (this.type && this.type == "wf") {
            //只是查看
            this.justShow = true;
          }
          this.showPhoto = true

          this.getOperationData(data.id)
        })
      }
    },
    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            this.formData.proofAttachment1 = uploadFileFormat(this.picList1)
            this.formData.proofAttachment2 = uploadFileFormat(this.picList2)
            this.formData.proofAttachment3 = uploadFileFormat(this.picList3)
            this.formData.answerAttachment1 = uploadFileFormat(this.picList4)
            this.formData.answerAttachment2 = uploadFileFormat(this.picList5)
            this.formData.answerAttachment3 = uploadFileFormat(this.picList6)
            this.$http({
              url: this.isEdit ? api.sfCheckBill.updateDataUrl : api.sfCheckBill.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success('保存成功')
              this.reload()
              this.$mask.close()

              // this.$emit('editViewDataUpdate')
              // this.$baseReload()
            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
          });
        }
      });
    },

    cancelForm() {
      this.loading = false;
      this.initiateAppeal = false;
      clearTimeout(this.timer);
    },


    async toInitiateAppeal() {
      try {
        this.loading = true;
        // 发送请求
        const res = await axios.post(api.sfCheckBill.siteAppeal, {
          id: this.dataId,
          siteAnswerNote: this.form2.siteAnswerNote,
          piclist: this.fileList,
          checkType: 1
        });
        if (res.data) {
          // 确保 el-drawer 组件已经初始化完成再关闭该窗口
          // this.$nextTick(() => {
          //   this.$refs.drawer.closeDrawer();
          // });
          this.$message.success('操作成功！');
          this.fileList = [];
          this.form2.siteAnswerNote = '';
          this.cancelForm()
          this.reload()
        } else {
          this.$message.error('操作失败，请稍后重试');
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },


    async cancleAppeal() {
      try {
        this.loading = true;
        // 发送请求
        const res = await axios.post(api.sfCheckBill.siteAppeal, {
          id: this.dataId,
          siteAnswerNote: this.form2.siteAnswerNote,
          piclist: this.fileList,
          checkType: 0
        });
        if (res.data) {
          // 确保 el-drawer 组件已经初始化完成再关闭该窗口
          // this.$nextTick(() => {
          //   this.$refs.drawer.closeDrawer();
          // });
          this.$message.success('操作成功！');
          this.fileList = [];
          this.form2.appealRemark = '';
          this.cancelForm()
          this.reload()
        } else {
          this.$message.error('操作失败，请稍后重试');
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    // 工单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.orderNo = row.orderNo
      this.formData.orderId = row.orderId
    },

    // 网点弹窗选中
    siteCommit(row) {
      console.log('网点弹窗选中',row)
      this.formData.siteId = row.id
      this.formData.siteName = row.name
      this.formData.orgId = row.orgId
      this.formData.orgName = row.orgName
      this.formData.orgIdPath = row.orgIdPath
      this.formData.siteMan = row.siteMan
      this.formData.siteMobile = row.siteManMobile
    },

    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      this.upload_btn1 = false
      console.log(res.data.url, "url")
      this.picList1 = [
        { url: res.data.url }
      ]
    },

    handleRemove2() {
      this.picList2 = []
    },
    // handleSuccess2(res, file, fileList) {
    //   this.upload_btn2 = false
    //   console.log(res.data.url, "url")
    //   this.picList2 = [
    //     {url: res.data.url}
    //   ]
    // },

    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      this.upload_btn3 = false
      console.log(res.data.url, "url")
      this.picList3 = [
        { url: res.data.url }
      ]
    },

    handleRemove4() {
      this.picList4 = []
    },
    handleSuccess4(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList4 = [
        { url: res.data.url }
      ]
    },

    handleRemove5() {
      this.picList5 = []
    },
    handleSuccess5(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList5 = [
        { url: res.data.url }
      ]
    },

    handleRemove6() {
      this.picList6 = []
    },
    handleSuccess6(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList6 = [
        { url: res.data.url }
      ]
    },
  },
};

</script>
<style lang="scss" scoped>
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 80px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 80px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 1px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  // border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 656px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  // background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}


#containt .detail-wrap .d-cont {
  overflow: unset !important;
  margin: 0 !important;
  padding: 0 !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

::v-deep .el-image {
  width: 60px;
}
.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
.Instructions {
  text-decoration: underline;
  color: #00c4b3;
  margin-left: 5px;
}
</style>
